export const environment = {
  production: false,
  skipPayment: false,
  adminEmailAddress: ['thefloortheory.tft@gmail.com'],
  /** Razorpay test key — replace with your actual test key */
  razorpayKeyId: 'rzp_test_SbQK4g148NQe2M',
  firebaseConfig: {
    apiKey: 'AIzaSyBUII3ng-fkBNooX9LKGgeh5HMpDzaO3Rc',
    authDomain: 'the-floor-theory-dev.firebaseapp.com',
    projectId: 'the-floor-theory-dev',
    storageBucket: 'the-floor-theory-dev.firebasestorage.app',
    messagingSenderId: '677474010928',
    appId: '1:677474010928:web:10c9166c75d50570376af5',
    measurementId: 'G-4T7NF6C2WZ',
  },
  recaptchaSiteKey: '6LcdvK4sAAAAALkIxQu5fr-5lCjGHprBI_-eYXLW',
};
